
import PreEntryApi from '../../assets/js/preentry'
import { i18nHelper } from '@it-common/lbp_common'
import OnboardHeader from '../OnboardHeader'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'


export default {
components: {
Flexbox,
XButton,
FlexboxItem,
Loading,
OnboardHeader,
Confirm
},
data () {
return {
id: '',
code: '',
isZH: true,
showLoading: true,
lejianIsNew: false,
jiankangNew: false,
lejianLoginUrl: '#',
physical_no: '',
physical_type: 1,
job_type: 1,
work_city_name: '',
physical_pass: '',
isPrivacyAuth: false,
showTips: false,
trigger_position: 1,
page_type: 1
}
},
created () {

var localStorage = window.localStorage
this.code = localStorage.getItem('pre_code')
this.isZH = localStorage.getItem('offer_zh') === 'zh'
i18nHelper.setFixedLocale(localStorage.getItem('offer_zh'))
this.$forceUpdate()
this.id = this.$route.query.id

if (!this.code || !this.id) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}

PreEntryApi.checkLogin(
{ id: this.id, code: this.code },

(data, meta) => {},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
},

err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
},

err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
)


PreEntryApi.getStaffDetail({ id: this.id, code: this.code }, (data, meta) => {
if (data) {
this.physical_no = data.physical_no
this.physical_pass = data.physical_pass
this.physical_type = data.physical_type
this.job_type = data.job_type
this.work_city_name = data.work_city_name
this.lejianLoginUrl =
data.physical_no.length > 10
? 'https://empapp.meinian365.com/login?code=3965437811054305'
: 'https://empapp.meinian365.com/login?code=3965437811054305'
this.lejianIsNew = data.physical_no.length < 10
if (data.id === data.physical_no) {
this.lejianLoginUrl = 'https://empapp.meinian365.com/login?code=3965437811054305'
this.jiankangNew = true
}
console.log('体检' + this.jiankangNew)
}
})
},
mounted () {
this.showLoading = false
i18nHelper.loadLanguagePack(4159)
this.id = this.$route.query.id
this.trigger_position = this.$route.query.trigger_position
this.isPrivacyAuth = this.$route.query.is_agree
if (this.trigger_position === 2) {
this.showTips = true
}
},
methods: {
downloadMedical () {
PreEntryApi.downloadMedical()
},

acceptOffer () {
this.$router.push({ name: 'onboard.material', query: { id: this.id, from: 'thanks' } })
},
goPreView () {
if (!this.isPrivacyAuth) {
this.showTips = true
this.trigger_position = 2
return true
} else {
this.trigger_position = 1
PreEntryApi.savePrivacy(

{ id: this.id, code: this.code, trigger_position: this.trigger_position, page_type: this.page_type, proto_content: ''},
() => {

this.$router.push({ name: 'onboard.material', query: { id: this.id, from: 'thanks'} })
},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
}
)
}
},

getIsZh (data) {
var localStorage = window.localStorage
if (data) {
localStorage.setItem('offer_zh', 'zh')
} else {
localStorage.setItem('offer_zh', 'en')
}
this.isZH = data
},
frontDownload (path, fileName) {
var a = document.createElement('a') 
a.href = path 
a.download = fileName 
a.style.display = 'none' 
document.body.appendChild(a) 
a.click() 
a.remove() 
},
onprivacyCancel () {
this.trigger_position = 1
},
onprivacyConfirm () {
this.isPrivacyAuth = true
this.trigger_position = 2
PreEntryApi.savePrivacy(

{ id: this.id, code: this.code, trigger_position: this.trigger_position, page_type: this.page_type, proto_content: ''},
() => {

this.$router.push({ name: 'onboard.material', query: { id: this.id, from: 'thanks'} })
},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
}
)
},
showPrivacyInfo () {
this.$router.push({ name: 'onboard.privacy_info', query: { id: this.id, trigger_position: this.trigger_position, is_agree: this.isPrivacyAuth, page_type: this.page_type } })
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/thanks.vue